<template>
  <div class="vaults-dashboard">
    <div
      class="
        w-full
        h-20
        bg-panels-gradient
        p-4
        flex
        justify-center
        items-center
      "
      v-if="$mq != 'mobile'"
    >
      <!-- <div class="sort"> -->
      <!-- <span class="font-medium mr-4">View By</span>
                <div class="inline-block relative w-40">
                    <select class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-4 py-2 pr-8 rounded shadow">
                        <option>Most Used</option>
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-grey-darker">
                        <i class="fa fa-angle-down"></i>
                    </div>
      </div>-->
      <!-- </div> -->
      <span class="text-center font-medium"
        >Drag and drop documents on the Vault to commence upload</span
      >
    </div>

    <div class="w-full bg-white">
      <div
        class="
          flex flex-col
          md:flex-row md:justify-center
          p-4
          md:p-6 md:items-center md:mb-6
        "
      >
        <div class="flex-1 flex flex-row md:items-center md:mr-8">
          <label
            for="search-vaults"
            class="uppercase font-semibold hidden md:block"
            >Search</label
          >
          <form
            class="
              search-pill
              border border-grey
              rounded-full
              p-2
              flex flex-row
              justify-between
              mx-2
              w-full
            "
            @submit.prevent="filterVaults"
          >
            <input
              type="text"
              class="flex-1 px-3 outline-none"
              id="search"
              placeholder="Enter a Vault Name"
              v-model="keyword"
              @input="filterVaults"
            />
            <button
              type="button"
              class="
                w-10
                h-10
                bg-grey
                text-white
                flex
                justify-center
                items-center
                rounded-full
              "
              v-if="keyword"
              @click.prevent="
                keyword = '';
                filterVaults();
              "
            >
              <i class="fa fa-times fa-lg"></i>
            </button>
            <button
              type="submit"
              class="
                w-10
                h-10
                bg-brand
                text-white
                flex
                justify-center
                items-center
                rounded-full
              "
              v-if="!keyword"
            >
              <i class="fa fa-search fa-lg"></i>
            </button>
          </form>
        </div>
        <a
          href="/add-vault"
          class="
            inline-flex
            my-4
            md:my-0 md:ml-8
            uppercase
            no-underline
            flex
            justify-center
            text-brand
            hover:text-brand-darker
          "
        >
          <div
            class="
              w-10
              h-10
              bg-brand
              text-white
              flex
              justify-center
              items-center
              rounded-full
            "
          >
            <i class="fa fa-plus fa-lg"></i>
          </div>
          <span class="self-center ml-2 font-semibold text-black"
            >Add a Vault</span
          >
        </a>
      </div>

      <vaults
        :vaults="vaults"
        :filtered-vaults="filtered_vaults"
        v-if="filtered_vaults.length != 0 && vaults.length != 0"
      ></vaults>

      <div
        v-else-if="filtered_vaults.length == 0 && vaults.length != 0"
        class="p-8 text-center text-xl bg-orange-lightest text-orange"
      >
        <i class="fa fa-exclamation-triangle text-orange"></i> No Vaults found
      </div>

      <div class="flex flex-col items-center mt-8" v-if="vaults.length == 0">
        <i class="fa fa-circle-notch fa-spin fa-3x fa-fw"></i>
        <span class="mt-2">Fetching your Vaults...</span>
      </div>
    </div>

    <!-- <price-increase-2023></price-increase-2023> -->
    <!-- <price-increase-2024></price-increase-2024> -->
    <price-increase-2025></price-increase-2025>
    <price-increase-2026></price-increase-2026>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Vaults from "../components/VaultsList/Vaults";
// import PriceIncrease2023 from "../components/Modals/PriceIncrease2023";
// import PriceIncrease2024 from "../components/Modals/PriceIncrease2024";
import PriceIncrease2026 from "../components/Modals/PriceIncrease2026";

export default {
  components: {
    Vaults,
    // PriceIncrease2023,
    // PriceIncrease2024,
    // PriceIncrease2025,
    PriceIncrease2026,
  },

  data() {
    return {
      keyword: "",
      filtered: false,
      filtered_vaults: [],
    };
  },

  created() {
    if (_.isEmpty(this.filtered_vaults)) {
      this.filtered_vaults = _.cloneDeep(this.vaults);
    }
  },

  methods: {
    filterVaults() {
      this.filtered = true;
      if (this.keyword == "") {
        this.filtered_vaults = _.cloneDeep(this.vaults);
      } else {
        this.filtered_vaults = this.vaults.filter((vault) => {
          return _.includes(
            vault.name.toLowerCase(),
            this.keyword.toLowerCase()
          );
        });
      }
    },
  },

  computed: {
    ...mapGetters({
      vaults: "getVaults",
    }),
  },

  watch: {
    vaults() {
      this.filtered = false;
      this.filtered_vaults = _.cloneDeep(this.vaults);
    },
  },
};
</script>

<style scoped>
#search {
  outline: none;
}
</style>
